import { render, staticRenderFns } from "./articledetail.vue?vue&type=template&id=5ce3fac4&scoped=true"
import script from "./articledetail.vue?vue&type=script&lang=js"
export * from "./articledetail.vue?vue&type=script&lang=js"
import style0 from "./articledetail.vue?vue&type=style&index=0&id=5ce3fac4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce3fac4",
  null
  
)

export default component.exports